<template>
  <div class="content">
    <div class="wrapper-features">
      <p class="features">NAJWAŻNIEJSZE CECHY <strong>KABLA USB</strong></p>
      <div class="main-features">
        <img src="@/assets/images/Charger/image002.png" alt="">
        <img src="@/assets/images/Charger/image004.png" alt="">
        <img src="@/assets/images/Charger/image006.png" alt="">
        <img src="@/assets/images/Charger/image008.png" alt="">
        <img src="@/assets/images/Charger/image010.png" alt="">
      </div>
    </div>
    <div class="section-1">
      <img src="@/assets/images/Charger/image012.png" alt="">
    </div>

    <div class="section-2">
      <h1 class="font-size-big title">Solidna budowa</h1>
      <p class="font-size-middle">Zastosowanie nylonowego oplotu ochroni przewód przed przełamaniami 
        oraz otarciami.</p>
      <img src="@/assets/images/Charger/image014.png" alt="">
    </div>

    <div class="section-3">
      <h1 class="font-size-big title">Podwójny wskaźnik LED</h1>
      <p class="font-size-middle">Złącze USB typu C zawiera podwójny wskaźnik LED dzięki czemu cały czas widzisz 
        czy Twoje urządzenie jest podłączone do ładowarki. Wskaźnik w połączeniu z <strong>VOCALE Tab 10 Pro</strong> 
        domyślnie świeci w trybie nocnym, jeśli jednak zamienisz stronę złącza to będzie widoczny moduł dzienny.</p>
      <img src="@/assets/images/Charger/image016.png" alt="">
    </div>

    <div class="TableSection">
      <table class="font-size-middle">
        <tbody>
        <tr>
          <th>
            Parametry fizyczne
          </th>
        </tr>
        <tr class="space"></tr>
        <tr>
          <td class="feature">
            Kolor
          </td>
          <td class="feature-value">
            Czarny
          </td>
        </tr>
        <tr>
          <td class="feature">
            Długość
          </td>
          <td class="feature-value">
            3 m
          </td>
        </tr>
        <tr>
          <td class="feature">
            Natężenie
          </td>
          <td class="feature-value">
            2A
          </td>
        </tr>
        <tr>
          <td class="feature">
            Głębokość [mm]
          </td>
          <td class="feature-value">
            9,5 mm
          </td>
        </tr>
        <tr>
          <td class="feature">
            Waga [kg]
          </td>
          <td class="feature-value">
            0,058 kg
          </td>
        </tr>
        <tr>
          <td class="feature">
            Złącze
          </td>
          <td class="feature-value">
            USB Typ-c do USB
          </td>
        </tr>
        <tr class="space"></tr>
        </tbody>
        <tbody>
        <tr>
          <th>
            Producent i znak zgodności
          </th>
        </tr>
        <tr class="space"></tr>
        <tr>
          <td class="feature">
            Nazwa producenta
          </td>
          <td class="feature-value">
            Mcdodo
          </td>
        </tr>
        <tr>
          <td class="feature">
            Nazwa importera
          </td>
          <td class="feature-value">
            Vocale Sp. z o. o.
          </td>
        </tr>
        <tr>
          <td class="feature">
            Znak zgodności
          </td>
          <td class="feature-value">
            <img src="@/assets/images/Charger/image018.jpg">
          </td>
        </tr>
        <tr class="space"></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Charger',
}
</script>

<style lang='scss' scoped>
@import '@/assets/scss/_variables.scss';



.content {
  .title {
    color: $primary;
    font-weight: normal;
  }

  .description {
    font-size: 24px;
  }

  .wrapper-features {
    margin: 60px auto 90px;
    width: fit-content;

    .features {
      font-weight: normal;
      margin-bottom: 40px;
      & > strong {
        color: $primary
      }
    }
    .main-features {
      & > img {
        max-width: 100px;
        min-width: 40px;
        margin-right: 20px;
      }

      & > img:first-child {
        margin-left: 20px;
      }

      & > img:last-child {
        margin-right: 0;
      }
    }
  }

  .section-1 {
    display: flex;
    justify-content: center;
    & > img {
      max-width: 700px;
    }

    .description {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-bottom: 80px;
      padding-left: 50px;
      .title {
        margin: 0.67em;
        margin-bottom: 1em;
      }

      & > img {
        max-width: 155px;
      }
    }
  }

  .section-2 {
    margin-top: 100px;

    & > p {
      width: 920px;
      margin: 0 auto 20px;
      strong {
        color: $primary;
        font-weight: normal;
      }
    }

    img {
      max-width: 669px;
    }
  }

  .section-3 {
    margin-top: 100px;

    & > p {
      width: 927px;
      margin: 0 auto 60px;

      strong {
        color: $primary;
        font-weight: normal;
      }
    }

    img {
      max-width: 700px;
    }
  }

  .section-4 {
    margin-top: 150px;
    margin-bottom: 140px;
    & > p {
      width: 912px;
      margin: 0 auto 50px;
      strong {
        color: $primary;
        font-weight: normal;
      }
    }
  }
}

.TableSection {
  display: flex;
  max-width: 90vw;
  margin-top: 50px;
  text-align: left;
  padding-right: 100px;

  @media screen and (max-width: 1024px) {
    padding: 0;
  }
  
  table {
    margin-left: auto;
    margin-right: auto;

    tr.space {
      height: 30px;
    }

    th {
      text-align: left;
      color: $primary;
      padding-right: 120px;
      @media only screen and (max-width: 600px) {
        padding-right: 10px;
      }
    }

    td.feature {
      color: white;
      text-align: right;
      font-weight: bold;
    }

    td.feature-value {
      padding-left: 20px;
      color: $dark-text;
    }
  }
}

@media screen and (max-width: 1280px) and (-webkit-min-device-pixel-ratio: 1.1) {

  .content {
    .wrapper-features {
      margin: 20px auto 20px;
      width: fit-content;

      .features {
        font-weight: normal;
        text-align: center;
        margin-bottom: 30px;
        & > strong {
          color: $primary
        }
      }
      .main-features {
        display: block;
        text-align: center;
        & > img {
          width: 16%;
          min-width: 40px;
          margin-right: 10px;
        }

        & > img:first-child {
          margin-left: 0;
        }

        & > img:last-child {
          margin-right: 0;
        }
      }
    }

    .section-1 {
      flex-direction: column;
      margin-left: 0;
      align-items: center;

      & > img {
        width: 280px;
      }
      .description {
        margin-top: 15px;
        padding: 0;
        img {
          width: 123px;
          margin: 0 auto;
        }
      }
    }

    .section-4 {
      margin-bottom: 30px;
    }

    .section-2, .section-3, .section-4 {
      margin-top: 50px;
    }

    .section-1, .section-2, .section-3{
      p {
        width: 100%;
      }

    img {
      width: 280px;
    }
    }
  }
}

@media screen and (max-width: $phone-max-width) {

  .content {
    .wrapper-features {
      margin: 20px auto 20px;
      width: fit-content;

      .features {
        font-weight: normal;
        text-align: center;
        margin-bottom: 30px;
        & > strong {
          color: $primary
        }
      }
      .main-features {
        display: block;
        text-align: center;
        & > img {
          width: 16%;
          min-width: 40px;
          margin-right: 10px;
        }

        & > img:first-child {
          margin-left: 0;
        }

        & > img:last-child {
          margin-right: 0;
        }
      }
    }

    .section-1 {
      flex-direction: column;
      margin-left: 0;
      align-items: center;

      & > img {
        width: 280px;
      }
      .description {
        margin-top: 15px;
        padding: 0;
        img {
          width: 123px;
          margin: 0 auto;
        }
      }
    }

    .section-4 {
      margin-bottom: 30px;
    }

    .section-2, .section-3, .section-4 {
      margin-top: 50px;
    }

    .section-1, .section-2, .section-3{
      p {
        width: 100%;
      }

    img {
      width: 280px;
    }
    }
  }
}

@media screen and (min-width: 600px) and (max-width: 1024px)  {
  .content {
    .wrapper-features {
      .main-features {
        & > img {
          margin-right: 20px;
        }

        & > img:first-child {
          margin-left: 20px;
        }

        & > img:last-child {
          margin-right: 0;
        }
      }
    }
    
    .section-1 {
      flex-direction: row;
      justify-content: center;

      & > img {
        width: 450px;
      }
    }

    img {
      width: 400px;
    }

    .TableSection {
      img {
        width: auto;
      }
    }
  }
}

</style>